import { AuthenticationService } from './AuthenticationService';
export type { AuthState, SessionState, SessionScope } from './AuthenticationService';
import { createUseAuthState } from './createUseAuthState';

export const auth = new AuthenticationService();

export const useAuthState = createUseAuthState(auth);
